module.exports = __webpack_public_path__ + "img/多云.656f3cf3.png";